export default "__VITE_ASSET__DHufoehi__"